import { Box } from "@chakra-ui/react";

export const Footer = () => {
  return(
    <Box >
      version 1.2.9
    </Box>
  );
}
